import type {
  LinkBuilderPresetRes,
  PublishedTagDefinition,
} from '@n3oltd/karakoram.tags.sdk.link-builder'

export interface TagDefinition {
  id: string
  name: string
  description?: string
  queryKey: string
  /** The key a picked value is emitted under. */
  idKey?: string
  optionsSource?: string
  optionsSourceParent?: string
}

export interface Preset {
  id: string
  revisionId: string
  name: string
  queryParameters: { tagKey: string; tagValue: string | undefined }[]
}


export function projectDefaultBaseUrl(raw: string | undefined): string | null {
  if (typeof raw !== 'string') return null
  const trimmed = raw.trim()
  return trimmed === '' ? null : trimmed
}

export function projectTagDefinitions(
  raw: ReadonlyArray<PublishedTagDefinition>,
): TagDefinition[] {
  const out: TagDefinition[] = []
  for (const def of raw) {
    if (def.autoPopulated !== false) continue
    if (def.scope?.id !== 'analyticsField') continue
    if (typeof def.id !== 'string' || def.id === '') continue
    if (typeof def.name !== 'string' || def.name === '') continue
    const queryKey = def.keys?.[0]
    if (typeof queryKey !== 'string' || queryKey === '') continue
    out.push({
      id: def.id,
      name: def.name,
      queryKey,
      ...(typeof def.description === 'string' && def.description !== ''
        ? { description: def.description }
        : {}),
      ...(typeof def.idKey === 'string' && def.idKey !== '' ? { idKey: def.idKey } : {}),
      ...(typeof def.optionsSource === 'string' && def.optionsSource !== ''
        ? { optionsSource: def.optionsSource }
        : {}),
      ...(typeof def.optionsSourceParent === 'string' && def.optionsSourceParent !== ''
        ? { optionsSourceParent: def.optionsSourceParent }
        : {}),
    })
  }
  return out
}

export function projectPresets(raw: ReadonlyArray<LinkBuilderPresetRes>): Preset[] {
  const out: Preset[] = []
  for (const p of raw) {
    if (typeof p.id !== 'string' || p.id === '') continue
    if (typeof p.revisionId !== 'string' || p.revisionId === '') continue
    if (typeof p.name !== 'string' || p.name === '') continue
    const params: Preset['queryParameters'] = []
    for (const qp of p.queryParameters ?? []) {
      if (typeof qp.tagKey !== 'string' || qp.tagKey === '') continue
      params.push({ tagKey: qp.tagKey, tagValue: qp.tagValue })
    }
    out.push({ id: p.id, revisionId: p.revisionId, name: p.name, queryParameters: params })
  }
  return out
}
